import {
	CoverState,
	CoverStateActions,
	SET_SELECTED_COVER,
	SET_COVER_ITEMS,
	SET_REPLACE_COVER_ITEMS,
	SET_MISSING_COVER,
	SET_NOT_PRELOADED_COVERS,
	SET_COVER_ONLY,
	SET_COVER_ONLY_ITEMS,
	SET_ADDITIONAL_COVER_ITEMS,
	CLEAR_ADDITIONAL_COVER_ITEMS,
} from './types';
import { CoverItem, ShoppingItem } from 'sofa-reborn-react';

const coverItems: CoverItem[] = [];
const coverOnlyItems: CoverItem[] = [];
const replaceCoverItems: CoverItem[] = [];
const additionalCoverItems: ShoppingItem[] = [];
const selectedCover = null;

const initialState: CoverState = {
	coverItems,
	replaceCoverItems,
	selectedCover,
	missingCover: false,
	notPreloadedCovers: null,
	coverOnlyItems,
	additionalCoverItems,
};

export function coverReducer(state = initialState, action: CoverStateActions): CoverState {
	switch (action.type) {
		case SET_SELECTED_COVER:
			return { ...state, selectedCover: action.value };
		case SET_COVER_ITEMS:
			return { ...state, coverItems: action.value };
		case SET_REPLACE_COVER_ITEMS:
			return { ...state, replaceCoverItems: action.value };
		case SET_MISSING_COVER: {
			return { ...state, missingCover: action.value };
		}
		case SET_NOT_PRELOADED_COVERS: {
			return { ...state, notPreloadedCovers: action.value };
		}
		case SET_COVER_ONLY: {
			return { ...state, coverOnly: action.value };
		}
		case SET_COVER_ONLY_ITEMS: {
			return { ...state, coverOnlyItems: action.value };
		}
		case SET_ADDITIONAL_COVER_ITEMS: {
			return { ...state, additionalCoverItems: action.value };
		}
		case CLEAR_ADDITIONAL_COVER_ITEMS: {
			return { ...state, additionalCoverItems: [] };
		}
		default:
			return state;
	}
}
